import React, { Component } from 'react'
import Banner from '../../components/tribe/tribe_banner2'
import './css/index.css'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer' 
import structurimage from '../../assets/image/strategy-organization/culture2.jpg'
export default class structur extends Component {
    render() {
        const image=[
            {image:structurimage}
        ]
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br className='hide-mobile'/><br className='hide-mobile'/>
                <div className='consulting-section'>
                    <Banner bread_crum={['Strategy and Organization','Structure']} image={image} title="Structure" subtitle=""/>
                    <br/><br/>
                    <div className='consulting-content'>
                        <h2>How we work</h2>
                        <br/><br/>
                        <div className='how'>
                            <p>
                                ”We help our clients in developing and implementing strategy-based organization structure that ensure their employees work effectively to achieve organization performance target.”
                                <br/><br/>
                                …through
                                <br/><br/>
                                Restructuring
                                <br/><br/>
                                Organization Structure represent clarity in distribution of responsibility and authority in the organization. Organization structure must aligned with organization strategy and it’s value chain. And organization must find a balance between horizontal (specialization) and vertical (authority) differentiation in defining the most effective structure.
                                <br/><br/>
                                Job Design & Analysis
                                <br/><br/>
                                In the field of Human Resources, the existence of a good Job Profile is a vital pre – requisite for effective management of Human Resources system. Job Design is a mechanism in creating Job Profile with Top Down approach, while Job Analysis is using the Bottom Up approach.
                                <br/><br/>
                                Job Evaluation System (Job Grading)
                                <br/><br/>
                                Job evaluation System is a methodology to define the worth of a Job (Job grading) based on several compensable factors. This methodology helps organization to achieve internal equity in pay for position (salary).
                                <br/><br/>
                                Workload Analysis
                                <br/><br/>
                                To achieve organization right sizing, Workload Analysis methodology is a useful tool in determining how many employee is needed to perform a job. By analysing the workload, organization can better plan their man power (Man Power Planning).
                            </p>
                        </div>
                    </div>
                </div>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
